import { Injectable } from "@angular/core";
import { combineLatest, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { SubmissionDetailsFacade } from "../../../../submission-details.facade";
import { FormDetailsComponentData } from "../../form-details.model";
import { SubmissionDetailsBaseComponentData } from "../../../../submission-details.model";
import { getFormDetailsAppBarActions, getFormDetailsHeaderData, FormDetailsAdapter, getSubmissionDetailsBannerData, getIncompleteSubmissionDialogData } from "../../form-details.data";
import { SubmissionsFacade } from "../../../../../../domain/+state/submissions.facade";
import { ApplicationData, ApplicationDocumentsQueryResult, ContactQueryResult } from "../../../../../../domain/models/application.model";
import { BrokerStatus } from "../../../../../../../../shared/SharedConstants";
import { SimpleDialogComponent, SimpleDialogData, AdvisorData } from "common";
import { MatDialog } from "@angular/material/dialog";

@Injectable()
export class IncompleteFormFacade {
  constructor(
    private readonly detailsFacade: SubmissionDetailsFacade,
    private readonly submissionsFacade: SubmissionsFacade,
    private readonly adapter: FormDetailsAdapter,
    private readonly dialog: MatDialog
  ) { }

  getComponentData$(applicationId: number): Observable<FormDetailsComponentData> {
    return this.detailsFacade.getComponentBaseData$(applicationId)
      .pipe(switchMap((data: SubmissionDetailsBaseComponentData) => {
        return this.getFormDetailsComponentData$(data);
      }));
  }

  private getFormDetailsComponentData$(data: SubmissionDetailsBaseComponentData): Observable<FormDetailsComponentData> {
    return combineLatest([
      this.submissionsFacade.getContactsData({ applicationId: <number>data.application.id }),
      this.submissionsFacade.getApplicationDocuments(<number>data.application.id),
      this.submissionsFacade.getAdvisorData$(<number>data.application.id)
    ]).pipe(
      map(([contacts, applicationDocuments, advisorData]: [ContactQueryResult, ApplicationDocumentsQueryResult, AdvisorData]) => {
        return {
          ...data,
          headerData: getFormDetailsHeaderData(data.application?.brokerStatus, advisorData),
          advisorData,
          appBarActions: getFormDetailsAppBarActions(),
          formData: this.adapter.adaptFormData(data.application, data.account, contacts?.values),
          documentsData: this.adapter.adaptDocumentsSectionData(applicationDocuments, data.application),
          bannerData: getSubmissionDetailsBannerData(data.application),
        }
      }))
  }

  openIncompleteSubmissionDialogIfNeeded(application: ApplicationData): void {
    if (application.brokerStatus !== BrokerStatus.SUBMISSION_INCOMPLETE) {
      return;
    }

    const dialogData: SimpleDialogData = getIncompleteSubmissionDialogData(application.incompleteInfo);
    SimpleDialogComponent.show(this.dialog, dialogData);
  }
}
